export const CLINIC_DOCS_LAYOUT = {
  SIDEBAR_WIDTH: 340,
} as const;
